import request from "@/utils/request";
import { ouchnCustom } from "@/service";

//根据字典查询字典信息——教学类、教辅类、学术类、试卷类、其他类、
export function teachingAttrList(dictType) {
  return request({
    url: ouchnCustom + "/web/goods/getDictListByDictType?dictType=" + dictType,
    method: "get",
  });
}

//查询某一项教学属性下的分类
export function TeachingClassList(catalogType) {
  return request({
    url:
      ouchnCustom + "/web/goods/getTreeSelectByType?catalogType=" + catalogType,
    method: "get",
  });
}
//查询书城商品列表
export function goodsList(data) {
  return request({
    url: ouchnCustom + "/web/goods/selGoodsList",
    method: "post",
    data: data,
  });
}
//查询书城详情商品详情信息
export function goodsInfoDetail(goodsId) {
  return request({
    url: ouchnCustom + "/web/goods/selGoodsById?goodsId=" + goodsId,
    method: "get",
  });
}
// 查询书城详情——推荐商品
export function recommendGoods(goodsId) {
  return request({
    url: ouchnCustom + "/web/goods/getRecomGoodsList?goodsId=" + goodsId,
    method: "get",
  });
}
// 查询书城详情——推荐专题
export function recommendSubject(goodsId) {
  return request({
    url: ouchnCustom + "/web/goods/getRecomSubjectList?goodsId=" + goodsId,
    method: "get",
  });
}
// 查询书城详情——商品评价
export function Listevaluate(query) {
  return request({
    url: ouchnCustom + "/web/goods/getEvaluateListByGoodsId",
    method: "get",
    params: query,
  });
}
// 加入购物车
export function CartAdd(goodsId, userId) {
  return request({
    url:
      ouchnCustom +
      "/web/api/ocShoppingCart/addShoppingCart?goodsId=" +
      goodsId +
      "&userId=" +
      userId,
    method: "get",
  });
}
//判断是否加入购物车
export function IsCartAdd(goodsId) {
  return request({
    url:
      ouchnCustom +
      "/web/api/ocShoppingCart/isAddShoppingCart?goodsId=" +
      goodsId,
    method: "get",
  });
}
//加入书架
export function BookshelfAdd(query) {
  return request({
    url: ouchnCustom + "/web/goods/addBookshelf",
    method: "get",
    params: query,
  });
}
//判断是否加入书架
export function IsBookshelfAdd(query) {
  return request({
    url: ouchnCustom + "/web/goods/isAddBookshelf",
    method: "get",
    params: query,
  });
}
//取消加入书架
export function delBookshelf(query) {
  return request({
    url: ouchnCustom + "/web/goods/delBookshelf",
    method: "get",
    params: query,
  });
}
//举报评论
export function reportComment(data) {
  return request({
    url: ouchnCustom + "/web/api/ocEvaluate/addReport",
    method: "post",
    data: data,
  });
}

//判断是否
export function checkIsBuy(params) {
  return request({
    url: ouchnCustom + "/web/read/selectIsBuy",
    method: "get",
    params,
  });
}
//判断商品状态
export function SelGoodsStatus(goodsId) {
  return request({
    url:
      ouchnCustom + "/web/api/ocShoppingCart/selGoodsStatus?goodsId=" + goodsId,
    method: "get",
  });
}
//判断专题状态
export function SelSubjectStatus(id) {
  return request({
    url: ouchnCustom + "/web/api/ocShoppingCart/selSubjectStatus?id=" + id,
    method: "get",
  });
}
//查看文件是否有阅读权限
export function isHavingPermissions(data) {
  return request({
    url: ouchnCustom + "/web/read/isHavingPermissions",
    method: "POST",
    data: data,
  });
}

//第三方阅读更新阅读记录和阅读进度
export function updateRecordAndSchedule(data) {
  return request({
    url: ouchnCustom + "/web/otherRead/updateRecordAndSchedule",
    method: "POST",
    data: data,
  });
}

//查询第三方阅读进度
export function selectReadSchedule(data) {
  return request({
    url:
      ouchnCustom +
      "/web/otherRead/selectReadSchedule?goodsFileId=" +
      data.goodsFileId +
      "&platformCode=" +
      data.platformCode +
      "&stuNum=" +
      data.stuNum,
    method: "GET",
    // data: data
  });
}

//查询第三方学生是否已购买
export function IsBuyResource(data) {
  return request({
    url: ouchnCustom + "/web/myResource/isBuyResource",
    method: "GET",
    params: data,
  });
}

//第三方记录阅读日志
export function addOrUpdate(data) {
  return request({
    url: ouchnCustom + "/device/readerLog/addOrUpdate",
    method: "POST",
    data: data,
  });
}

//查询是否访问本地系统
export function getSysInfo(data) {
  return request({
    url: ouchnCustom + "/web/read/getSysInfo",
    method: "GET",
    params: data,
  });
}

//查询学科分类树
export function getClassList(data) {
  return request({
    url: ouchnCustom + "/web/api/homePage/getClassList",
    method: "GET",
    params: data,
  });
}
export function getClassResourcesList(data) {
  return request({
    url: ouchnCustom + "/web/api/homePage/getClassResourcesList",
    method: "GET",
    params: data,
  });
}

// 获取所有目录和目录下关联的文件
export function getGoodsCatalogAndFiles(data) {
  return request({
    url: ouchnCustom + "/web/goods/getGoodsCatalogAndFiles",
    method: "GET",
    params: data,
  });
}

